var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('v-divider', {
    staticClass: "primary border-2"
  }), _c('v-data-table', _vm._b({
    attrs: {
      "hide-default-footer": "",
      "disable-filtering": "",
      "disable-sort": ""
    },
    on: {
      "click:row": _vm.onClickRow
    },
    scopedSlots: _vm._u([_vm._l(_vm.headers.filter(function (header) {
      return header.hasOwnProperty('formatter');
    }), function (header) {
      return {
        key: `item.${header.value}`,
        fn: function (_ref) {
          var value = _ref.value;
          return [_vm._v(" " + _vm._s(header.formatter(value)) + " ")];
        }
      };
    }), {
      key: `item.subject`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('list-item-subject', _vm._b({}, 'list-item-subject', {
          item
        }, false))];
      }
    }, {
      key: `item.isReplied`,
      fn: function (_ref3) {
        var value = _ref3.value;
        return [value ? [_c('span', {
          staticClass: "primary--text"
        }, [_vm._v(" 답변완료 ")])] : [_c('span', [_vm._v(" 답변대기 ")])]];
      }
    }, {
      key: "expanded-item",
      fn: function (_ref4) {
        var item = _ref4.item;
        return _c('td', {
          staticClass: "pa-0 grey-f8",
          attrs: {
            "colspan": _vm.headers.length
          }
        }, [_c('list-item-content', _vm._g(_vm._b({}, 'list-item-content', {
          item,
          items: _vm.items,
          program: _vm.program,
          loading: _vm.loading
        }, false), {
          remove: _vm.remove,
          update: _vm.update,
          updateItem: _vm.updateItem
        }))], 1);
      }
    }, {
      key: "footer",
      fn: function () {
        return [_c('v-divider'), _c('v-pagination', {
          staticClass: "my-8",
          attrs: {
            "length": _vm.pageCount,
            "total-visible": 11,
            "color": "primary"
          },
          model: {
            value: _vm.page,
            callback: function ($$v) {
              _vm.page = $$v;
            },
            expression: "page"
          }
        })];
      },
      proxy: true
    }], null, true)
  }, 'v-data-table', {
    headers: _vm.headers,
    items: _vm.items,
    itemKey: '_id',
    itemClass: _vm.itemClass,
    itemsPerPage: -1,
    loading: _vm.loading
  }, false))], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }